import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './gif/fillMainInfo.gif'
import _imports_1 from './gif/createSurveyTest.gif'


const _withScopeId = n => (_pushScopeId("data-v-0bdff078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tile is-parent p-0" }
const _hoisted_2 = { class: "tile is-child" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Hi! ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Some information about creating surveys ", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" To get started, we need to create our first survey. Creating and editing surveys is done in the ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Surveys section", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". Creating a survey is divided into 2 sections: Main info and Tests. ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tile is-parent p-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tile is-vertical is-7" }, [
    /*#__PURE__*/_createElementVNode("article", { class: "tile is-child" }, [
      /*#__PURE__*/_createElementVNode("h2", null, " Main info "),
      /*#__PURE__*/_createElementVNode("p", null, " The Main info section fills in basic information about the survey, such as: name, description, timing, tags, skills. Tags and skills can be selected from a predefined one or create your own. "),
      /*#__PURE__*/_createElementVNode("blockquote", null, " The tag will be created by pressing the \"Create new tag\" button and pressing Enter after entering the tag name ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("figure", { class: "mr-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      loading: "lazy",
      src: _imports_0,
      alt: "Filling survey main info"
    }),
    /*#__PURE__*/_createElementVNode("figcaption", null, " Filling survey main info ")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tile is-parent p-0 tests-section" }, [
  /*#__PURE__*/_createElementVNode("figure", { class: "ml-0" }, [
    /*#__PURE__*/_createElementVNode("img", {
      loading: "lazy",
      src: _imports_1,
      alt: "Create survey test"
    }),
    /*#__PURE__*/_createElementVNode("figcaption", null, " Create survey test ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tile is-vertical is-7" }, [
    /*#__PURE__*/_createElementVNode("article", { class: "tile is-child" }, [
      /*#__PURE__*/_createElementVNode("h2", null, " Tests "),
      /*#__PURE__*/_createElementVNode("p", null, " In the Tests section, you can create tests of the survey. In the survey can be unlimited number of tests, but the main thing that would be created at least one test. After pressing the \"Create test\" button the window of test creation will be shown. When you create a test, you must fill in the Name and description fields to describe the question, as well as select the type of question. The type of question can be text, code or choice of the correct answer. ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CView = _resolveComponent("CView")!

  return (_openBlock(), _createBlock(_component_CView, { title: "Home page" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("article", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                to: {name: _ctx.surveysRouteName}
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_8
            ])
          ])
        ])
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ]),
    _: 1
  }))
}